import axios from "axios";
import { Constants } from '../utils/Constants';

export function login(email, password) {
	return axios.post(`${Constants.baseUrl}/auth`, { email, password });
}

export function getMe() {
	return axios.get(`${Constants.baseUrlV2}/me`);
}

export function verificarEmail(token) {
	return axios.post(`${Constants.url}/api/v2/email/verify`, { token });
}

export function verificarStatusEmail() {
	return axios.get(`${Constants.url}/api/v2/web/patio/email/verify/status`);
}

export function esqueciSenha(data) {
	return axios.post(`${Constants.baseUrlV2}/esqueci-senha`, data);
}

export function alterarSenha(data) {
	return axios.post(`${Constants.baseUrlV2}/alterar-senha`, data);
}
